var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { "grid-list-md": "", fluid: "", "pa-2": "" } },
    [
      _c(
        "v-layout",
        { attrs: { wrap: "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "" } },
            [
              _c(
                "panel",
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      !_vm.$LOCAL && (!_vm.hits || !_vm.hits.query)
                        ? [_c("NameField", { attrs: { ticket: _vm.ticket } })]
                        : _vm.hits
                        ? [
                            _c("span", { staticClass: "hidden-sm-and-down" }, [
                              _vm._v("Results: "),
                            ]),
                            _vm._v(" "),
                            _c("small", { staticClass: "ticket" }, [
                              _vm._v(_vm._s(_vm.hits.query.header)),
                            ]),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  !_vm.$LOCAL && _vm.resultState == "PENDING"
                    ? _c(
                        "div",
                        { attrs: { slot: "desc" }, slot: "desc" },
                        [
                          _c(
                            "v-container",
                            {
                              attrs: { "fill-height": "", "grid-list-md": "" },
                            },
                            [
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c("v-flex", { attrs: { xs4: "" } }, [
                                    _c("img", {
                                      staticStyle: { "max-width": "100%" },
                                      attrs: {
                                        src: require("./assets/marv-search_2x.png"),
                                        srcset:
                                          require("./assets/marv-search_2x.png") +
                                          " 2x, " +
                                          require("./assets/marv-search_3x.png") +
                                          " 3x",
                                      },
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _c("v-flex", { attrs: { xs8: "" } }, [
                                    _c("h3", [_vm._v("Still Pending")]),
                                    _vm._v(" "),
                                    _c("p", [_vm._v("Please wait a moment")]),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : !_vm.$LOCAL && _vm.resultState == "EMPTY"
                    ? _c(
                        "div",
                        { attrs: { slot: "desc" }, slot: "desc" },
                        [
                          _c(
                            "v-container",
                            {
                              attrs: { "fill-height": "", "grid-list-md": "" },
                            },
                            [
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c("v-flex", { attrs: { xs4: "" } }, [
                                    _c("img", {
                                      staticStyle: { "max-width": "100%" },
                                      attrs: {
                                        src: require("./assets/marv-result_2x.png"),
                                        srcset:
                                          require("./assets/marv-result_2x.png") +
                                          " 2x, " +
                                          require("./assets/marv-result_3x.png") +
                                          " 3x",
                                      },
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _c("v-flex", { attrs: { xs8: "" } }, [
                                    _c("h3", [_vm._v("No hits found!")]),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      [
                                        _vm._v("Start a "),
                                        _c(
                                          "v-btn",
                                          { attrs: { to: "/search" } },
                                          [_vm._v("New Search")]
                                        ),
                                        _vm._v("?"),
                                      ],
                                      1
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : !_vm.$LOCAL && _vm.resultState != "RESULT"
                    ? _c(
                        "div",
                        { attrs: { slot: "desc" }, slot: "desc" },
                        [
                          _c(
                            "v-container",
                            {
                              attrs: { "fill-height": "", "grid-list-md": "" },
                            },
                            [
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c("v-flex", { attrs: { xs4: "" } }, [
                                    _c("img", {
                                      staticStyle: { "max-width": "100%" },
                                      attrs: {
                                        src: require("./assets/marv-error_2x.png"),
                                        srcset:
                                          require("./assets/marv-error_2x.png") +
                                          " 2x, " +
                                          require("./assets/marv-error_3x.png") +
                                          " 3x",
                                      },
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _c("v-flex", { attrs: { xs8: "" } }, [
                                    _c("h3", [_vm._v("Error! ")]),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      [
                                        _vm._v("Start a "),
                                        _c(
                                          "v-btn",
                                          { attrs: { to: "/search" } },
                                          [_vm._v("New Search")]
                                        ),
                                        _vm._v("?"),
                                      ],
                                      1
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.resultState == "RESULT" && _vm.hits && _vm.hits.results
                    ? _c(
                        "template",
                        { slot: "content" },
                        [
                          _c(
                            "v-menu",
                            {
                              ref: "menuwrapper",
                              staticStyle: { "z-index": "99999 !important" },
                              attrs: { "offset-y": "", absolute: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function ({
                                      on: activation,
                                      attrs: attrs,
                                    }) {
                                      return [
                                        _c(
                                          "div",
                                          { staticStyle: { display: "none" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                (_vm.menuActivator = activation)
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                3471006822
                              ),
                            },
                            [
                              _vm._v(" "),
                              _c(
                                "v-list",
                                _vm._l(_vm.menuItems, function (item, index) {
                                  return _c(
                                    "v-list-item",
                                    {
                                      key: index,
                                      attrs: {
                                        "two-line": "",
                                        href: item.href,
                                        target: "_blank",
                                        rel: "noopener",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-list-item-content",
                                        [
                                          _c("v-list-item-title", [
                                            _vm._v(_vm._s(item.label)),
                                          ]),
                                          _vm._v(" "),
                                          _c("v-list-item-subtitle", [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(item.accession) +
                                                "\n                                "
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-sheet",
                            {
                              staticClass: "sticky-tabs",
                              staticStyle: {
                                position: "sticky",
                                "padding-bottom": "2em",
                                top: "64px",
                                "z-index": "99999 !important",
                              },
                            },
                            [
                              _vm.hits.results.length > 1
                                ? _c(
                                    "v-tabs",
                                    {
                                      attrs: {
                                        color:
                                          _vm.selectedDatabases > 0
                                            ? _vm.hits.results[
                                                _vm.selectedDatabases - 1
                                              ].color
                                            : null,
                                        "center-active": "",
                                        grow: "",
                                        "show-arrows": "",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.handleChangeDatabase()
                                        },
                                      },
                                      model: {
                                        value: _vm.selectedDatabases,
                                        callback: function ($$v) {
                                          _vm.selectedDatabases = $$v
                                        },
                                        expression: "selectedDatabases",
                                      },
                                    },
                                    [
                                      _c("v-tab", [_vm._v("Summary")]),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.hits.results,
                                        function (entry) {
                                          return _c(
                                            "v-tab",
                                            { key: entry.db },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  entry.db.replaceAll(
                                                    /_folddisco$/g,
                                                    ""
                                                  )
                                                ) +
                                                  " (" +
                                                  _vm._s(
                                                    entry.alignments
                                                      ? Object.values(
                                                          entry.alignments
                                                        ).length
                                                      : 0
                                                  ) +
                                                  ")"
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.hits &&
                          _vm.hits.results &&
                          _vm.hits.results.length > 1
                            ? _c("TopHits", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.selectedDatabases == 0,
                                    expression: "selectedDatabases == 0",
                                  },
                                ],
                                attrs: {
                                  hits: _vm.hits,
                                  mode: 2,
                                  queryPdb: _vm.queryPdb,
                                },
                                on: {
                                  jumpTo: (i) =>
                                    (_vm.selectedDatabases = i + 1),
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "keep-alive",
                            [
                              _vm.hits &&
                              _vm.hits.results &&
                              _vm.hits.results.length > 1 &&
                              _vm.selectedDatabases == 0
                                ? _c("Top100Folddisco", {
                                    ref: "top100",
                                    attrs: {
                                      hits: _vm.hits,
                                      alignment: _vm.alignment,
                                      selectedStates: _vm.selectedStates,
                                      selectedCounts: _vm.selectedCounts,
                                      selectUpperbound: _vm.selectUpperbound,
                                    },
                                    on: {
                                      showAlignment: (o, db, e) =>
                                        _vm.showAlignment(o, db, e),
                                      toggleSelection: (db, i, v) =>
                                        _vm.handleToggleSelection(db, i, v),
                                      bulkToggle: (a, v) =>
                                        _vm.handleBulkToggleFromTop100(a, v),
                                      forwardDropdown: (e, h) =>
                                        _vm.forwardDropdown(e, h),
                                      clearAll: _vm.clearAllEntries,
                                      jumpTo: (i) =>
                                        (_vm.selectedDatabases = i + 1),
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.hits.results, function (entry, entryidx) {
                            return entryidx + 1 == _vm.selectedDatabases
                              ? _c("ResultFoldDiscoDB", {
                                  key: entry.db,
                                  ref: "dbComponent" + entryidx,
                                  refInFor: true,
                                  attrs: {
                                    entryidx: entryidx,
                                    entry: entry,
                                    toggleSourceDb: _vm.toggleSourceDb,
                                    selectedStates:
                                      _vm.selectedStates[entryidx],
                                    selectedCounts:
                                      _vm.selectedCountPerDb[entryidx],
                                    totalSelectedCounts: _vm.selectedCounts,
                                    selectUpperbound: _vm.selectUpperbound,
                                    alignment: _vm.alignment,
                                    onlyOne: _vm.hits.results.length == 1,
                                    tableState: _vm.tableStates[entry.db],
                                  },
                                  on: {
                                    "update:tableState": (state) =>
                                      _vm.$set(
                                        _vm.tableStates,
                                        entry.db,
                                        state
                                      ),
                                    forwardDropdown: (e, h) =>
                                      _vm.forwardDropdown(e, h),
                                    showAlignment: (i, e) =>
                                      _vm.showAlignment(i, entry.db, e),
                                    updateToggleSource: (db) =>
                                      _vm.updateToggleSourceDb(db),
                                    toggleSelection: (i, v) =>
                                      _vm.handleToggleSelection(entryidx, i, v),
                                    bulkToggle: (a, v) =>
                                      _vm.handleBulkToggle(entryidx, a, v),
                                    updateScroll: () =>
                                      _vm.updateScrollOffsetArr(),
                                    clusterInfo: (info) =>
                                      _vm.handleClusterInfo(entryidx, info),
                                    clearAll: _vm.clearAllEntries,
                                  },
                                })
                              : _vm._e()
                          }),
                        ],
                        2
                      )
                    : _vm._e(),
                ],
                2
              ),
              _vm._v(" "),
              _c("SelectToSendPanel", {
                ref: "sendPanel",
                attrs: {
                  hits: _vm.hits,
                  ticket: _vm.ticket,
                  selectedCounts: _vm.selectedCounts,
                  isComplex: false,
                  selectUpperbound: _vm.selectUpperbound,
                  dbToIdx: _vm.dbToIdx,
                  banList: [],
                  closeAlignment: _vm.closeAlignment,
                  getSingleSelectionInfo: _vm.getSingleSelectionInfo,
                  getMultipleSelectionInfo: _vm.getMultipleSelectionInfo,
                  getSinglePdb: _vm.getPdbToSend,
                  getMockPdb: _vm.getPdbToSend,
                  getOrigPdb: _vm.getOrigPdbToSend,
                  batchSize: 4,
                  chunkSize: 32,
                },
                on: { clearAll: _vm.clearAllEntries },
              }),
              _vm._v(" "),
              _c("NavigationButton", {
                attrs: {
                  selectedDatabases: _vm.selectedDatabases,
                  scrollOffsetArr: _vm.scrollOffsetArr,
                  tabOffset: _vm.tabOffset,
                  hasMoreClusters: _vm.hasMoreClusters,
                },
                on: {
                  needUpdate: _vm.updateScrollOffsetArr,
                  needRenderNext: _vm.handleNeedRenderNext,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "portal",
        [
          _vm.alignment != null && _vm.targetPdb != null
            ? _c(
                "panel",
                {
                  directives: [
                    {
                      name: "click-outside",
                      rawName: "v-click-outside",
                      value: _vm.closeAlignment,
                      expression: "closeAlignment",
                    },
                  ],
                  staticClass: "alignment",
                  style: "top: " + _vm.alnBoxOffset + "px;",
                },
                [
                  _c(
                    "template",
                    { slot: "desc" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticStyle: {
                            display: "block",
                            "margin-left": "auto",
                          },
                          attrs: { icon: "" },
                          on: { click: _vm.closeAlignment },
                        },
                        [
                          _c("v-icon", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.$MDI.CloseCircleOutline) +
                                "\n                "
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("StructureViewerMotif", {
                    key: `ap-${_vm.alignment.dbkey}`,
                    attrs: {
                      slot: "content",
                      alignment: _vm.alignment,
                      queryPdb: _vm.queryPdb,
                      targetPdb: _vm.targetPdb,
                      lineLen: _vm.fluidLineLen,
                    },
                    slot: "content",
                  }),
                ],
                2
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }